import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  standalone: true,
  name: 'attachmentNameLimit',
})
export class AttachmentNameLimitPipe implements PipeTransform {
  private lengthLimit: number = 20;
  transform(value: string): string {
    if (value.length > this.lengthLimit) {
      const truncatedValue = value.substring(0, this.lengthLimit);
      const nameparts = value.split('.');
      if (nameparts.length > 1) {
        return `${truncatedValue}...${nameparts[nameparts.length - 1]}`;
      } else {
        return `${truncatedValue}...`;
      }
    }
    return value;
  }
}

